import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { ReportService,MessageService } from "@services";
import { AppBaseComponent } from "@utils";



@Component({
  selector: 'app-reports-solicitudes',
  templateUrl: './reports-solicitudes.component.html',
  styleUrls: ['./reports-solicitudes.component.scss']
})
export class ReportsSolicitudesComponent extends AppBaseComponent implements OnInit {
  reportForm: FormGroup;

  constructor(private fb: FormBuilder,
    private reportService: ReportService,
    private popupAlert: MessageService,
    private popUpService: MessageService) {
    super();
  }

  ngOnInit(): void {
    this.reportForm = this.fb.group({
      idTipoPersona: ['', [Validators.required]],
      fechaInicial: ['', [Validators.required, super.dateValidator]],
      fechaFinal: ['', [Validators.required, super.dateValidator]]
    })
  }

  verificarFecha() {
    //Bloquea del calendario desplegable
    const datepicker1 = document.getElementById('fecha-inicial');
    const datepicker2 = document.getElementById('fecha-final');
    const today = new Date();
    let date = today.getDate() > 9 ? today.getDate() :
      `0${today.getDate()}`;
    let month = today.getMonth() > 9 ? today.getMonth() + 1 :
      `0${today.getMonth() + 1}`;
    let year = today.getFullYear();

    datepicker1.setAttribute('max', `${year}-${month}-${date}`);
    datepicker2.setAttribute('max', `${year}-${month}-${date}`);

  }

  generarReporte(): void {

    if (!this.reportForm.valid) {
      this.popupAlert.errorAlert(
        `Por favor, revise el formulario del reporte, hay datos invalidos y/o incompletos.`,
        4000
      );
      console.log("FORMULARIO PROCESADO");
      console.log(this.reportForm.value);
      console.log("ERRORES FORMULARIO");
      console.log(super.getAllErrors(this.reportForm));
      this.reportForm.markAllAsTouched();
      return;
    }

    const idTipoPersona = this.reportForm.get('idTipoPersona').value;
    const fechaInicial = this.reportForm.get('fechaInicial').value;
    const fechaFinal = this.reportForm.get('fechaFinal').value;

    if (fechaFinal < fechaInicial) {
      this.popUpService.errorAlert("La fecha final no puede ser menor a la fecha inicial", 3000)
      return;
    }

    console.log("INFORMACION A ENVIAR");
    console.log("IdTipoPersona enviado: ", idTipoPersona);
    console.log("fechaInicial enviado: ", fechaInicial);
    console.log("fechaFinal enviado: ", fechaFinal);
    this.reportService.getReportDataSST(idTipoPersona, fechaInicial, fechaFinal).subscribe(resp => {

      this.downloadCSV(resp, idTipoPersona);
    }
    )
  }

  downloadCSV(datos: any, juridica: number) {
    console.log("🚀 ~ file: reports-solicitudes.component.ts:78 ~ ReportsSolicitudesComponent ~ downloadCSV ~ datos", JSON.stringify(datos));
    let element = document.createElement('a');
    let datatable = [];
    let opciones = {};


    if (datos && datos.length > 0 && juridica == 1 || juridica == 2) {
      for (let i in datos) {
        let tipo = '';

        let ob = {
          'desctipodoc': datos[i].tipodocumento,
          'nume_identificacion': datos[i].numeroidentificacion,
          'tipo_iden_rl(rl: representante legal)': datos[i].tipodocumentoCode,
          'nume_iden_rl': datos[i].representantelegalnumero,
          'nombre_rs(razón social)': datos[i].nombre,
          'primer_apellido': datos[i].primer_apellido,
          'segundo_apellido': datos[i].segundo_apellido,
          'primer_nombre': datos[i].primer_nombre,
          'segundo_nombre': datos[i].segundo_nombre,
          'Sexo': datos[i].sexo,
          'Genero': datos[i].genero,
          'Orientacion': datos[i].orientacion,
          'Departamento Nacimiento': datos[i].departamentonacimiento,
          'Ciudad Nacimiento': datos[i].ciudadnacimiento,
          'Fecha Nacimiento': datos[i].fecha_nacimiento,
          'Estado civil': datos[i].estadocivil,
          'Codigo pais Nacionalidad': datos[i].codPaisNacionalidad,
          'Departamento Residencia': datos[i].depa_resi,
          'Ciudad Residencia': datos[i].ciudad_resi,
          'Direccion': datos[i].direccionresi,
          'Telefono Fijo': datos[i].telefono_celular,
          'Telefono Celular': datos[i].telefono_celular,
          'Email': datos[i].emailpersona,
          'Etnia': datos[i].etnia,
          'Nivel Educativo': datos[i].nivel_educativo,
          'id Tramite': datos[i].id_tramite,
          'Tipo Tramite': datos[i].tipo_tramite,
          'Fecha_creacion': datos[i].fecha_creacion,
          'id_estado': datos[i].id_estado,
          'Estado': datos[i].descripcionEstado,
        }
        datatable.push(ob);
      }

      let textoPlano = '';
      textoPlano = 'desctipodoc;nume_identificacion;tipo_iden_rl(rl: representante legal);nume_iden_rl;nombre_rs(razón social);primer_apellido;segundo_apellido;primer_nombre;segundo_nombre;Sexo;Genero;Orientacion;Departamento Nacimiento;Ciudad Nacimiento' +
        ';Fecha Nacimiento;Estado civil;Codigo pais Nacionalidad;Departamento Residencia;Ciudad Residencia;Direccion;Telefono Fijo;' +
        'Telefono Celular;Email;Etnia;Nivel Educativo;id Tramite;Tipo Tramite;Fecha_creacion;id_estado;Estado \n';

      for (let inf in datatable) {
        textoPlano += datatable[inf]['desctipodoc'] + ';'
          + datatable[inf]['nume_identificacion'] + ';'
          + datatable[inf]['tipo_iden_rl(rl: representante legal)'] + ';'
          + datatable[inf]['nume_iden_rl'] + ';'
          + datatable[inf]['nombre_rs(razón social)'] + ';'
          + datatable[inf]['primer_apellido'] + ';'
          + datatable[inf]['segundo_apellido'] + ';'
          + datatable[inf]['primer_nombre'] + ';'
          + datatable[inf]['segundo_nombre'] + ';'
          + datatable[inf]['Sexo'] + ';'
          + datatable[inf]['Genero'] + ';'
          + datatable[inf]['Orientacion'] + ';'
          + datatable[inf]['Departamento Nacimiento'] + ';'
          + datatable[inf]['Ciudad Nacimiento'] + ';'
          + datatable[inf]['Fecha Nacimiento'] + ';'
          + datatable[inf]['Estado civil'] + ';'
          + datatable[inf]['Codigo pais Nacionalidad'] + ';'
          + datatable[inf]['Departamento Residencia'] + ';'
          + datatable[inf]['Ciudad Residencia'] + ';'
          + datatable[inf]['Direccion'] + ';'
          + datatable[inf]['Telefono Fijo'] + ';'
          + datatable[inf]['Telefono Celular'] + ';'
          + datatable[inf]['Email'] + ';'
          + datatable[inf]['Etnia'] + ';'
          + datatable[inf]['Nivel Educativo'] + ';'
          + datatable[inf]['id Tramite'] + ';'
          + datatable[inf]['Tipo Tramite'] + ';'
          + datatable[inf]['Fecha_creacion'] + ';'
          + datatable[inf]['id_estado'] + ';'
          + datatable[inf]['Estado'] + ' \n';
      }


      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(textoPlano));
      let nombre = juridica == 2 ? 'reporte_solicitudesPJ.csv' : 'reporte_solicitudesPN.csv';

      element.setAttribute('download', nombre);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);

    }

  }
  downloadExcel(datos: any) {

    const ExportJsonExcel = require('js-export-excel');
    let datatable = [];
    let opciones = {};

    if (datos && datos.length > 0) {
      for (let i in datos) {
        let tipo = '';
        let ob = {
          'Identificador': datos[i].id_tramite,
          'Primer Nombre': datos[i].primer_nombre,
          'Primer Apellido': datos[i].primer_apellido,
          'Segundo Nombre': datos[i].segundo_nombre,
          'Segundo Apellido': datos[i].segundo_apellido,
          'Identificacion': datos[i].numeroidentificacion,
          'Sexo': datos[i].sexo,
          'Genero': datos[i].genero,
          'Orientacion': datos[i].orientacion,
          'Departamento Nacimiento': datos[i].departamentonacimiento,
          'Ciudad Nacimiento': datos[i].ciudadnacimiento,
          'Fecha Nacimiento': datos[i].fecha_nacimiento,
          'Estado civil': datos[i].estadocivil,
          'Codigo pais Nacionalidad': datos[i].codPaisNacionalidad,
          'Departamento Residencia': datos[i].depa_resi,
          'Ciudad Residencia': datos[i].ciudad_resi,
          'Direccion': datos[i].direccionresi,
          'Telefono': datos[i].telefono_celular,
          'Email': datos[i].emailpersona,
          'Etnia': datos[i].etnia,
          'Nivel Educativo': datos[i].nivel_educativo,
          'Estado': datos[i].descripcionEstado,
          'Tipo Tramite': datos[i].tipo_tramite,
          'Tipo Documento persona': datos[i].tipodocumento,
          'Codigo Tipo Doc': datos[i].tipodocumentoCode,
          'Direccion Territorio': datos[i].direccionterritorial,
          'Resolucion': datos[i].resolucion,
          'Fecha Expedicion': datos[i].fechaexpedicion,
          'Fecha Renovacion': datos[i].fecharenovacion,
          'Fecha creacion': datos[i].fecha_creacion,
          'Nombre': datos[i].nombre,
          'Representante Legal': datos[i].representantelegalnombre,
          'Numero identificacion': datos[i].representantelegalnumero,
          'Codigo Verificacion persona Juridica': datos[i].codigoverifJuridica,
          'Tipo Documento': datos[i].representantelegaltipoDoc,
          'Codigo Documento': datos[i].tipodocumentoCode,
          'Programa': datos[i].programa,
          'Titulo profesional': datos[i].tituloprofesion,
          'Tipo titulo': datos[i].tipotitulo,
          'Doctorado?': datos[i].namedoctorado
        }
        datatable.push(ob);
      }

      opciones = {
        fileName: 'reporteSolicitudes',
        datas: [
          {
            sheetData: datatable,
            sheetName: 'Historial solicitudes',
            sheetFilter: ['Identificador',
              'Primer Nombre',
              'Primer Apellido',
              'Segundo Nombre',
              'Segundo Apellido',
              'Identificacion',
              'Sexo',
              'Genero',
              'Orientacion',
              'Departamento Nacimiento',
              'Ciudad Nacimiento',
              'Fecha Nacimiento',
              'Estado civil',
              'Codigo pais Nacionalidad',
              'Departamento Residencia',
              'Ciudad Residencia',
              'Direccion',
              'Telefono',
              'Email',
              'Etnia',
              'Nivel Educativo',
              'Estado',
              'Tipo Tramite',
              'Tipo Documento persona',
              'Codigo Tipo Doc',
              'Direccion Territorio',
              'Resolucion',
              'Fecha Expedicion',
              'Fecha Renovacion',
              'Fecha creacion',
              'Nombre',
              'Representante Legal',
              'Numero identificacion',
              'Codigo Verificacion persona Juridica',
              'Tipo Documento',
              'Codigo Documento',
              'Programa',
              'Titulo profesional',
              'Tipo titulo',
              'Doctorado?'],
            sheetHeader: ['Identificador',
              'Primer Nombre',
              'Primer Apellido',
              'Segundo Nombre',
              'Segundo Apellido',
              'Identificacion',
              'Sexo',
              'Genero',
              'Orientacion',
              'Departamento Nacimiento',
              'Ciudad Nacimiento',
              'Fecha Nacimiento',
              'Estado civil',
              'Codigo pais Nacionalidad',
              'Departamento Residencia',
              'Ciudad Residencia',
              'Direccion',
              'Telefono',
              'Email',
              'Etnia',
              'Nivel Educativo',
              'Estado',
              'Tipo Tramite',
              'Tipo Documento persona',
              'Codigo Tipo Doc',
              'Direccion Territorio',
              'Resolucion',
              'Fecha Expedicion',
              'Fecha Renovacion',
              'Fecha creacion',
              'Nombre',
              'Representante Legal',
              'Numero identificacion',
              'Codigo Verificacion persona Juridica',
              'Tipo Documento',
              'Codigo Documento',
              'Programa',
              'Titulo profesional',
              'Tipo titulo',
              'Doctorado?']
          }
        ]
      };


      let toExcel = new ExportJsonExcel(opciones);
      toExcel.saveExcel();
    }

  }

  getErrorMessage(field: string): string {
    let message;
    let campoObligatorio = "Es requerido";
    let fechaErronea = "La fecha no puede ser una fecha futura o superior a la de hoy";


    if(this.isTouchedField(this.reportForm, field))
    {
      if(this.reportForm?.get(field).hasError('required'))
      {
        message = campoObligatorio;
      }
      else if(this.reportForm?.get(field).hasError('invalidDate'))
      {
        message = fechaErronea;
      }
    }

    return message;
  }


}
